var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05089 15.956C3.7424 14.2901 3.52754 13.1199 3.49059 12.2291C3.45449 11.359 3.59686 10.8976 3.87678 10.5611C4.15669 10.2246 4.58444 10.0006 5.44656 9.87768C6.32921 9.75181 7.51893 9.75 9.21312 9.75H14.7869C16.4811 9.75 17.6708 9.75181 18.5534 9.87768C19.4156 10.0006 19.8433 10.2246 20.1232 10.5611C20.4031 10.8976 20.5455 11.359 20.5094 12.2291C20.4725 13.1199 20.2576 14.2901 19.9491 15.956C19.7283 17.1481 19.574 17.9744 19.3783 18.5933C19.1889 19.1925 18.9861 19.5094 18.7212 19.7298C18.4563 19.9502 18.1077 20.0918 17.4841 20.169C16.8399 20.2487 15.9993 20.25 14.7869 20.25H9.21313C8.00073 20.25 7.16014 20.2487 6.5159 20.169C5.89229 20.0918 5.54374 19.9502 5.27881 19.7298C5.01387 19.5094 4.81111 19.1925 4.6217 18.5933C4.42604 17.9744 4.27166 17.1481 4.05089 15.956Z",
    stroke: "#2E2B63",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 8V12.25C15.5 12.6642 15.8358 13 16.25 13C16.6642 13 17 12.6642 17 12.25V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V12.25C7 12.6642 7.33579 13 7.75 13C8.16421 13 8.5 12.6642 8.5 12.25V8C8.5 6.067 10.067 4.5 12 4.5C13.933 4.5 15.5 6.067 15.5 8Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.acb07a8b1cc9acf77550f49844cd5002.svg";
export { ForwardRef as ReactComponent };